import TextInput from "@scripts/react/components/TextInput";
import { useModel } from "@rapid/contexts/ModelContext";
import { useIsGeneratingPredictions } from "@rapid/hooks/useIsGeneratingPredictions";
import { useFlow } from "@rapid/contexts/FlowContext";

export const TextPrompt = () => {
    const { textPromptStr, setTextPromptStr } = useModel();
    const isGeneratingPredictions = useIsGeneratingPredictions();
    const { isExtractingWithAI } = useFlow();

    // Text input is always enabled (except during active generation/extraction)
    // New text prompts will generate predictions for new classes and append to existing annotations
    return (
        <TextInput
            placeholder="Enter objects: person, card, dog..."
            disabled={isGeneratingPredictions || isExtractingWithAI}
            value={textPromptStr}
            onChange={setTextPromptStr}
            fullWidth={true}
        />
    );
};
